import { BorderClasses_Border_$ctor_Z207A3CFB, BorderClasses_BorderImageWidth_$ctor_Z207A3CFB, BorderClasses_BorderSpacing_$ctor_Z207A3CFB, BorderClasses_BorderColorParent_$ctor_Z207A3CFB, BorderClasses_BorderColor_$ctor_Z207A3CFB, BorderClasses_BorderImageSlice_$ctor_Z207A3CFB, BorderClasses_BorderImageRepeat_$ctor_Z207A3CFB, BorderClasses_BorderImageOutset_$ctor_Z207A3CFB, BorderClasses_BorderCollapse_$ctor_Z207A3CFB, BorderClasses_BorderStyleParent_$ctor_Z207A3CFB, BorderClasses_BorderStyle_$ctor_Z207A3CFB, BorderClasses_BorderRadiusEdge_$ctor_Z207A3CFB, BorderClasses_BorderRadius_$ctor_Z207A3CFB, BorderClasses_BorderWidthParent_$ctor_Z207A3CFB, BorderClasses_BorderWidth_$ctor_Z207A3CFB } from "../Types/Border.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";
import { ImageClasses_ImageClass_$ctor_Z207A3CFB } from "../Types/Image.fs.js";

export const BorderWidth = BorderClasses_BorderWidth_$ctor_Z207A3CFB(new Property_CssProperty(58));

export const BorderTopWidth = BorderClasses_BorderWidthParent_$ctor_Z207A3CFB(new Property_CssProperty(56));

export const BorderRightWidth = BorderClasses_BorderWidthParent_$ctor_Z207A3CFB(new Property_CssProperty(48));

export const BorderBottomWidth = BorderClasses_BorderWidthParent_$ctor_Z207A3CFB(new Property_CssProperty(31));

export const BorderLeftWidth = BorderClasses_BorderWidthParent_$ctor_Z207A3CFB(new Property_CssProperty(43));

export const BorderRadius = BorderClasses_BorderRadius_$ctor_Z207A3CFB(new Property_CssProperty(45));

export const BorderTopLeftRadius = BorderClasses_BorderRadiusEdge_$ctor_Z207A3CFB(new Property_CssProperty(53));

export const BorderTopRightRadius = BorderClasses_BorderRadiusEdge_$ctor_Z207A3CFB(new Property_CssProperty(54));

export const BorderBottomRightRadius = BorderClasses_BorderRadiusEdge_$ctor_Z207A3CFB(new Property_CssProperty(29));

export const BorderBottomLeftRadius = BorderClasses_BorderRadiusEdge_$ctor_Z207A3CFB(new Property_CssProperty(28));

export const BorderStyle = BorderClasses_BorderStyle_$ctor_Z207A3CFB(new Property_CssProperty(51));

export const BorderTopStyle = BorderClasses_BorderStyleParent_$ctor_Z207A3CFB(new Property_CssProperty(55));

export const BorderRightStyle = BorderClasses_BorderStyleParent_$ctor_Z207A3CFB(new Property_CssProperty(47));

export const BorderBottomStyle = BorderClasses_BorderStyleParent_$ctor_Z207A3CFB(new Property_CssProperty(30));

export const BorderLeftStyle = BorderClasses_BorderStyleParent_$ctor_Z207A3CFB(new Property_CssProperty(42));

export const BorderCollapse = BorderClasses_BorderCollapse_$ctor_Z207A3CFB(new Property_CssProperty(33));

export const BorderImageOutset = BorderClasses_BorderImageOutset_$ctor_Z207A3CFB(new Property_CssProperty(36));

export const BorderImageRepeat = BorderClasses_BorderImageRepeat_$ctor_Z207A3CFB(new Property_CssProperty(37));

export const BorderImageSlice = BorderClasses_BorderImageSlice_$ctor_Z207A3CFB(new Property_CssProperty(39));

export const BorderColor = BorderClasses_BorderColor_$ctor_Z207A3CFB(new Property_CssProperty(34));

export const BorderTopColor = BorderClasses_BorderColorParent_$ctor_Z207A3CFB(new Property_CssProperty(52));

export const BorderRightColor = BorderClasses_BorderColorParent_$ctor_Z207A3CFB(new Property_CssProperty(46));

export const BorderBottomColor = BorderClasses_BorderColorParent_$ctor_Z207A3CFB(new Property_CssProperty(27));

export const BorderLeftColor = BorderClasses_BorderColorParent_$ctor_Z207A3CFB(new Property_CssProperty(41));

export const BorderSpacing = BorderClasses_BorderSpacing_$ctor_Z207A3CFB(new Property_CssProperty(50));

export const BorderImageWidth = BorderClasses_BorderImageWidth_$ctor_Z207A3CFB(new Property_CssProperty(40));

export const BorderImageSource = ImageClasses_ImageClass_$ctor_Z207A3CFB(new Property_CssProperty(38));

export const Border = BorderClasses_Border_$ctor_Z207A3CFB(new Property_CssProperty(26));

